import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.paleSkyBlue,
  textColorDark: colors.black,
  textColorLight: colors.white,
  cardRadius: '20px'
};
export default fiftyFiftyCard;